import BaseFeature from '../../foundation/base/base';

class Accordion extends BaseFeature {
	constructor(element) {
		super(element);
		this.initDomCache();

		this.el = element;
		this.accordion = this.el;
		this.body = window.features.dom.body;
		this.accrodionContent = this.el.querySelector('[data-js="accrodionContent"]');
		this.accrodionTrigger = this.el.querySelectorAll('[data-js="accrodionTrigger"]');
		this.addClick();
	}

	addClick() {
		this.accrodionTrigger.forEach((el) => {
			el.addEventListener('click', () => {
				let elementState = el.getAttribute('aria-expanded');
				if (elementState === 'true') {
					elementState = 'false';
				} else {
					elementState = 'true';
				}
				el.setAttribute('aria-expanded', elementState);
			});

			window.addEventListener('keyup', (e) => {
				const isFocused = document.activeElement === el;
				if (isFocused && e.keyCode === 13) {
					e.preventDefault();
					// Trigger the button element with a click
					el.click();
				}
			});
		});
	}
}

export default Accordion;
